import * as React from "react";
import { Button } from "@progress/kendo-react-buttons";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { TextArea } from "@progress/kendo-react-inputs";
import { Label } from "@progress/kendo-react-labels";
import ErrorBanner from "../../components/ErrorBanner";
import { useMutateOverrideClientOEStatus } from "../../data/services/clientService";

const OverrideOEStatusDialog = ({ clientId, oePeriodId, onClose, onSuccess }) => {
  const [reason, setReason] = React.useState("");
  const [submitted, setSubmitted] = React.useState(false);

  const overrideStatusHandler = useMutateOverrideClientOEStatus();

  const handleSubmit = async () => {
    setSubmitted(true);
    try {
      await overrideStatusHandler.mutateAsync({
        clientId,
        oePeriodId,
        reason: reason.trim(),
      });
      onSuccess();
    } catch {
      setSubmitted(false);
    }
  };

  const isSubmitDisabled = !reason || reason.trim().length < 5 || submitted;

  return (
    <Dialog title="Override Not Started Status" onClose={onClose} width={500}>
      <div style={{ padding: "10px 0" }}>
        <div
          style={{
            marginBottom: "16px",
            padding: "8px 12px",
            backgroundColor: "#fff3cd",
            borderRadius: "4px",
            fontSize: "13px",
          }}
        >
          This will move the client from Not Started to In Progress so a
          contribution model can be submitted on their behalf. Use this only
          when the client will not log into the portal themselves.
        </div>

        <div style={{ marginBottom: "8px" }}>
          <Label>Reason for override (required)</Label>
          <TextArea
            value={reason}
            onChange={(e) => setReason(e.value)}
            rows={3}
            placeholder="Describe why this override is needed..."
            style={{ width: "100%" }}
          />
          {reason.length > 0 && reason.trim().length < 5 && (
            <div style={{ color: "red", fontSize: "12px", marginTop: "4px" }}>
              Reason must be at least 5 characters.
            </div>
          )}
        </div>
      </div>

      <ErrorBanner handler={overrideStatusHandler} onError={() => setSubmitted(false)} />

      <DialogActionsBar layout="end">
        <Button onClick={onClose} disabled={submitted}>
          Cancel
        </Button>
        <Button themeColor="warning" onClick={handleSubmit} disabled={isSubmitDisabled}>
          Override Status
        </Button>
      </DialogActionsBar>
    </Dialog>
  );
};

export default OverrideOEStatusDialog;
